import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';
import { color as col } from '@starrez/starryui9';

export const NotesFlag = ({ color = col.Grey.G70, ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            d="M9.8 12.3535C9.63431 12.3535 9.5 12.4878 9.5 12.6535C9.5 12.8192 9.63431 12.9535 9.8 12.9535H14.2C14.3657 12.9535 14.5 12.8192 14.5 12.6535C14.5 12.4878 14.3657 12.3535 14.2 12.3535H9.8Z"
            fill={color}
        />
        <path
            d="M9.5 14.0939C9.5 13.9283 9.63431 13.7939 9.8 13.7939H14.2C14.3657 13.7939 14.5 13.9283 14.5 14.0939C14.5 14.2596 14.3657 14.3939 14.2 14.3939H9.8C9.63431 14.3939 9.5 14.2596 9.5 14.0939Z"
            fill={color}
        />
        <path
            d="M9.8 15.2344C9.63431 15.2344 9.5 15.3687 9.5 15.5344C9.5 15.7001 9.63431 15.8344 9.8 15.8344H14.2C14.3657 15.8344 14.5 15.7001 14.5 15.5344C14.5 15.3687 14.3657 15.2344 14.2 15.2344H9.8Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9 7H12.5V10.3536C12.5 10.6297 12.7239 10.8536 13 10.8536H16V16C16 16.5523 15.5523 17 15 17H9C8.44771 17 8 16.5523 8 16V8C8 7.44772 8.44772 7 9 7ZM15.7929 9.85355L13.5 7.56066V9.85355H15.7929Z"
            fill={color}
        />
    </StarryUIIcon>
);
